<template>
  <div class="faq-section">
    <div class="wrapper">
      <div class="faq-header">
        <div class="title big">{{ title }}</div>
        <div v-if="description" class="desc faq-description">
          {{ description }}
        </div>
      </div>

      <ul class="list">
        <li v-for="(item, index) in items" :key="index" class="item">
          <div class="icon"></div>
          <div class="title">{{ item.question }}</div>
          <div class="desc small">{{ item.answer }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqSection",
  props: {
    title: {
      type: String,
      default: "Q&A",
    },
    description: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [
        {
          question: "How does your site work?",
          answer:
            "Our platform lets you browse and purchase Rust and Dota 2 skins and items through a simple, user-friendly interface. Just sign in, pick the items you're interested in, and follow the on-screen steps to complete your selection.",
        },
        {
          question: "Is it safe to use your site?",
          answer:
            "We take security seriously and follow industry-standard practices to keep your experience smooth and reliable. We recommend always keeping your Steam account protected with Steam Guard and following general online safety guidelines.",
        },
        {
          question: "How do I receive my skins?",
          answer:
            "Skins are delivered directly to your Steam inventory through the standard Steam trade system. Delivery times may vary depending on Steam's current status and your account settings.",
        },
        {
          question: "What if I have more questions?",
          answer:
            "Our support team is here to help. Feel free to reach out through the contact options on our site, and we'll get back to you as soon as possible.",
        },
      ],
    },
  },
};
</script>

<style scoped>
.faq-section {
  margin-top: 160px;
}

.faq-header {
  max-width: 900px;
  margin: 0 auto 40px;
  text-align: center;
}

.faq-description {
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.72);
}

.faq-section .list {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;
  gap: 20px;
}

.faq-section .item {
  border-radius: 12px;
  background-color: var(--bg-second-black);
  padding: 24px;
  text-align: left;
  line-height: 0;
  margin-bottom: 0;
  position: relative;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.12);
}

.faq-section .icon {
  width: 32px;
  height: 32px;
  position: absolute;
  background-image: url("~@/assets/tooltip.svg");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.faq-section .title {
  font-size: 18px;
  font-weight: 700;
  line-height: 32px;
  color: #fff;
  margin-left: 42px;
}

.faq-section .title.big {
  font-weight: 700;
  font-size: 62px;
  line-height: 76px;
  margin-left: 0;
}

.faq-section .desc {
  margin-top: 16px;
}

.faq-section .desc.small {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

@media screen and (max-width: 900px) {
  .faq-section .list {
    gap: 16px;
  }
}

@media screen and (max-width: 768px) {
  .faq-section {
    margin-top: 120px;
  }

  .faq-section .list {
    grid-template-columns: repeat(1, 1fr);
    justify-items: center;
  }

  .faq-section .item {
    width: 100%;
    max-width: 320px;
  }
}
</style>
